import type { PortfolioItemGroupName } from '@savvy/constants/generated/gql-types';
import defaultGuard from '@savvy/utils/default-guard';

export function getFirstDateOfData(
  portfolioItemGroups: readonly {
    historicalValues: readonly { date: string }[];
  }[],
) {
  return portfolioItemGroups
    .map((portfolioItemGroup) => portfolioItemGroup.historicalValues[0]?.date)
    .reduce((previousValue: string | null, currentValue) => {
      if (!previousValue || (currentValue && currentValue < previousValue)) {
        return currentValue ?? null;
      }
      return previousValue;
    }, null);
}

export type PortfolioItemGroupDisplayName =
  | 'Cash'
  | 'Real estate'
  | 'Savvy investments'
  | 'Other assets'
  | 'Other investments'
  | 'Company equity'
  | 'Other liabilities'
  | 'Other';

export function mapPortfolioItemGroupNameToDisplayName(
  portfolioItemGroupName: PortfolioItemGroupName,
): PortfolioItemGroupDisplayName {
  switch (portfolioItemGroupName) {
    case 'BANK_ACCOUNTS':
      return 'Cash';
    case 'REAL_ESTATE':
      return 'Real estate';
    case 'SAVVY_ACCOUNTS':
      return 'Savvy investments';
    case 'OTHER_ASSETS':
      return 'Other assets';
    case 'OTHER_INVESTMENTS':
      return 'Other investments';
    case 'COMPANY_EQUITY':
      return 'Company equity';
    case 'OTHER_LIABILITIES':
      return 'Other liabilities';
    default:
      return defaultGuard(portfolioItemGroupName, 'Other');
  }
}
